module.exports = __webpack_public_path__ + "static/stacheldraht-kl@2x.a0d84804.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Stacheldraht/stacheldraht-kl@2x.png
// module id = 440
// module chunks = 35783957827783